import { Injectable } from '@angular/core';
import { UrlBasePathService } from '../../utils/UrlBasePathUtil';

@Injectable()
export class LocalStorageService {
  constructor(private urlBasePathService: UrlBasePathService) {
  }

  setItem(key, value) {
    key = this.urlBasePathService.getBasePath() + key;
    return localStorage.setItem(key, value);
  }

  getItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    return localStorage.getItem(key);
  }

  removeItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    return localStorage.removeItem(key);
  }
}
